import type { SignupSourcesResponse } from "@atsready/shared";
import { request } from "./api-client";
import type {
  AnalyticsOverview,
  SubscriptionBreakdown,
  AIUsageByFeature,
  RetentionCohort,
  ExportReportType,
  ExportReportOptions,
} from "./types";

export type {
  AnalyticsOverview,
  SubscriptionBreakdown,
  AIUsageByFeature,
  RetentionCohort,
  ExportReportType,
  ExportReportOptions,
  SignupSourcesResponse,
};

export async function getAnalyticsOverview(): Promise<{ data: AnalyticsOverview }> {
  return request("/analytics/overview");
}

export async function getUserMetrics(days?: number): Promise<{
  data: {
    usersPerDay: Array<{ date: string; count: number }>;
    aiUsagePerDay: Array<{ date: string; total: number }>;
  };
}> {
  const query = days ? `?days=${days}` : "";
  return request(`/analytics/users${query}`);
}

export async function getSignupSources(days?: number): Promise<{ data: SignupSourcesResponse }> {
  const query = days ? `?days=${days}` : "";
  return request(`/analytics/signup-sources${query}`);
}

export async function getRevenueMetrics(days?: number): Promise<{
  data: {
    revenuePerDay: Array<{ date: string; total: number }>;
    totalRevenue: number;
  };
}> {
  const query = days ? `?days=${days}` : "";
  return request(`/analytics/revenue${query}`);
}

export async function getSubscriptionBreakdown(): Promise<{ data: SubscriptionBreakdown }> {
  return request("/analytics/subscriptions");
}

export async function getAIUsageByFeature(days?: number): Promise<{ data: AIUsageByFeature[] }> {
  const query = days ? `?days=${days}` : "";
  return request(`/analytics/ai-usage${query}`);
}

export async function getRetentionCohorts(weeks?: number): Promise<{ data: RetentionCohort[] }> {
  const query = weeks ? `?weeks=${weeks}` : "";
  return request(`/analytics/retention${query}`);
}

export async function exportReport(options: ExportReportOptions): Promise<Blob> {
  return request("/reports/export", {
    method: "POST",
    body: JSON.stringify(options),
  });
}
